<template>
  <b-modal :title="`Add Number`" v-model="visible" @ok="save" @cancel="hide" ok-title="Save" :ok-disabled="!canSave || saving">
    <b-row>
      <b-col cols="12">
        <b-form-group>
          <label for="number">Number</label>
          <b-form-input type="text" id="number" placeholder="i.e. 1 (785) 123-4567" v-model="number"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group>
          <label for="callerid">Caller ID</label>
          <b-form-input type="text" id="callerid" placeholder="i.e. VirtuPhone LLC" v-model="callerid"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    canSave () {
      const number = this.number.toString().replace(/\D/g, '')
      if ((number.length === 10 || number.length === 11) && this.callerid.length > 0) {
        return true
      }
      return false
    },
    ...mapGetters({
      account: 'global/account'
    }),
  },
  data () {
    return {
      visible: false,
      saving: false,
      number: '',
      callerid: ''
    }
  },
  methods: {
    async save () {
      let number = this.number.toString().replace(/\D/g, '')
      const callerid = this.callerid
      if (number.length === 10 && number[0] != '1') number = `1${number}`

      const numberData = {
        accountId: this.account.id,
        number,
        callerid,
        status: 'porting'
      }

      const { data } = await this.$axios.post(`/v1/numbers`, numberData)
      this.$emit('add', data)
    },
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    }
  },
  mounted () {
    this.$bus.$on('modal:addNumber', () => {
      this.show();
    })
  },
  beforeDestroy () {
    this.$bus.$off('modal:addNumber')
  }
}
</script>
